import { render, staticRenderFns } from "./zhichuHuozhu.vue?vue&type=template&id=ff319c3a&scoped=true&"
import script from "./zhichuHuozhu.vue?vue&type=script&lang=js&"
export * from "./zhichuHuozhu.vue?vue&type=script&lang=js&"
import style0 from "./zhichuHuozhu.vue?vue&type=style&index=0&id=ff319c3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff319c3a",
  null
  
)

export default component.exports